import { useProjectStore } from '@/providers/projectStoreProvider';
import { vodAsset } from '@/types/entities';
import { useGetVideoUrl } from '@/hooks/useGetVideoUrl';
import { StudioVideo } from '@/features/ai-video-creator/stores/studioVideoStore';

const useGetPlayerUrl = (video: StudioVideo): string => {
  const projects = useProjectStore((state) => state.projects);

  const videoUrl = useGetVideoUrl(video);

  if (!videoUrl) {
    return '';
  }

  if (!projects.length) {
    return videoUrl;
  }
  const id = video.vodAsset?.id || video.id;

  return `${process.env.NEXT_PUBLIC_PLAYER_URL}/feed/${projects[0]?.publishId}?isDynamic=true&vodAssetId=${id}`;
};

export default useGetPlayerUrl;
